import React, { createContext, useState } from "react";






interface RouterInfo {
    url?: string,
    track?: string,
}


interface RouterInfoContextProps {
    routerInfo: RouterInfo | null,
    setRouterInfo: React.Dispatch<React.SetStateAction<RouterInfo | null>>
}


export const RouterInfoContext = createContext<RouterInfoContextProps>({

    routerInfo: {
        url: '',
        track: ''
    },
    setRouterInfo: ()=>{return}
})

export const RouterInfoProvider: React.FC<any> = ({children})=>{
    
    const [routerInfo, setRouterInfo] = useState<RouterInfo | null>(null)

    return(
        <RouterInfoContext.Provider value={{routerInfo, setRouterInfo}}>
            {children}
        </RouterInfoContext.Provider>
    )
}